import { render, staticRenderFns } from "./contentRecommend.vue?vue&type=template&id=3398e2de&"
import script from "./contentRecommend.vue?vue&type=script&lang=js&"
export * from "./contentRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports